import WhatsNewInnerPageSideBySideTextAndAssetComponent from "./whats-new-inner-page-side-by-side-text-and-asset-component";
import WhatsNewInnerPageSideBySideTextAndAssetConfig from "./whats-new-inner-page-side-by-side-text-and-asset-config";
import WhatsNewInnerPageSideBySideTextAndAssetAdvancedConfig from "./whats-new-inner-page-side-by-side-text-and-asset-advanced-config";

export default {
  WhatsNewInnerPageSideBySideTextAndAssetComponent,
  WhatsNewInnerPageSideBySideTextAndAssetConfig,
  WhatsNewInnerPageSideBySideTextAndAssetAdvancedConfig
};
